import r from "./index.es43.js";
function p(t, e) {
  const u = {
    status: e ? "draft" : "published",
    filters: {
      slug: {
        $eq: t
      }
    },
    populate: {
      categories: {
        populate: {
          categoryPages: {
            populate: "*"
          }
        }
      },
      summary: {
        populate: "*"
      }
    }
  };
  return r.stringify(u);
}
export {
  p as default
};
//# sourceMappingURL=index.es11.js.map
